import React from 'react';
import PropTypes from 'prop-types';

/**
 * ModalContent:
 *  - The wrapper component that renders the contents of MicroCentrifuge Modals
 */
export function ModalContent(props) {
  return <div className={props.className}>{props.children}</div>;
}

ModalContent.propTypes = {
  /**
   * ClassName to set on componet
   */
  className: PropTypes.string,
  /**
   * Children to be rendered in component
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

ModalContent.defaultProps = {};
